import React from "react";
import { AlertTriangle, Mic, MicOff, Video, VideoOff } from "lucide-react";
import { cn } from "@/lib/utils";

interface BoothModerationBannerProps {
  isMutedByAdmin: boolean;
  isCameraDisabledByAdmin: boolean;
}

/**
 * Banner shown to users when their media has been restricted by admin/host
 */
const BoothModerationBanner: React.FC<BoothModerationBannerProps> = ({
  isMutedByAdmin,
  isCameraDisabledByAdmin,
}) => {
  if (!isMutedByAdmin && !isCameraDisabledByAdmin) return null;

  return (
    <div className={cn(
      "flex items-center gap-2 px-3 py-2 rounded-lg text-sm",
      "bg-amber-500/10 border border-amber-500/30 text-amber-600"
    )}>
      <AlertTriangle className="w-4 h-4 flex-shrink-0" />
      <div className="flex-1">
        {isMutedByAdmin && isCameraDisabledByAdmin ? (
          <span className="flex items-center gap-1.5">
            <MicOff className="w-3.5 h-3.5" />
            <VideoOff className="w-3.5 h-3.5" />
            Audio & camera disabled by moderator
          </span>
        ) : isMutedByAdmin ? (
          <span className="flex items-center gap-1.5">
            <MicOff className="w-3.5 h-3.5" />
            Audio muted by moderator
          </span>
        ) : (
          <span className="flex items-center gap-1.5">
            <VideoOff className="w-3.5 h-3.5" />
            Camera disabled by moderator
          </span>
        )}
      </div>
    </div>
  );
};

export default BoothModerationBanner;
